if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.loaded) return;
        createObserver({
          element: this,
          callback: this.init.bind(this),
          threshold: 400
        });
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.loaded = true;
            } else {
              let isHidden = this.getAttribute('data-hidden') === 'true';
              isHidden && this.remove();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}